import addDays from 'date-fns/addDays';
import dayjs from 'dayjs';

import { getTimeWithGMTKz } from '@/shared/utils/get-time-with-gmt';

export function dateWaiting(time: string): string {
    const timeFormating = dayjs(addDays(new Date(time), 1)).diff(getTimeWithGMTKz(), 'minutes');

    const timeWait = timeFormating < 3000 && timeFormating > 0 ? timeFormating : 0;

    const hours = Math.floor(timeWait / 60);

    const minutes = Math.floor(timeWait % 60);

    return `${hours >= 10 ? hours : `0${hours}`}:${minutes >= 10 ? minutes : `0${minutes}`}`;
}
